"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr, key) {
    var result = {};
    arr.forEach(function (ele) {
        var kv = ele[key];
        if (!result[kv]) {
            result[kv] = [];
        }
        result[kv].push(ele);
    });
    return result;
};